// extracted by mini-css-extract-plugin
export default {"body":"main_body__1qqDO","wrapper":"main_wrapper__63Lwv","column":"main_column__2URRl"};